module.exports = __webpack_public_path__ + "img/28.febe085d.jpg";